export default __webpack_public_path__ + "static/mosaic-cursor-do-light-c9f563a0dabaf09fe5c4247de22c19d71f2f6ed37fd2dba49f05bfadf6920323.png";